import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { IconAlertTriangleFilled } from '@calendly/ui/components/glyphs/IconAlertTriangleFilled';
import { UiIcon } from '@calendly/ui/components/ui-icon';
import { colorTextWarning } from '@calendly/ui/theme';
import { cx } from '@linaria/core';
import { useRef } from 'react';
export const tabPanelId = tabKey => `et-crud-tabpanel-${tabKey}`;
export const tabId = tabKey => `et-crud-tab-${tabKey}`;
const navCss = "nkj34va";
const tabItemCss = "t1vrvwb4";
const tabItemActiveCss = "tiw01sa";
const tabLabelCss = "t1hoypuo";
export const TabNav = ({
  tabs,
  activeTabKey,
  onSelectTab,
  invalidTabKeys = [],
  className
}) => {
  const tabRefs = useRef([]);
  const focusAndSelect = index => {
    const nextIndex = (index + tabs.length) % tabs.length;
    const nextTab = tabs[nextIndex];
    if (!nextTab) return;
    tabRefs.current[nextIndex]?.focus();
    onSelectTab(nextTab.key);
  };
  const handleKeyDown = (event, index) => {
    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        focusAndSelect(index + 1);
        break;
      case 'ArrowUp':
        event.preventDefault();
        focusAndSelect(index - 1);
        break;
      case 'Home':
        event.preventDefault();
        focusAndSelect(0);
        break;
      case 'End':
        event.preventDefault();
        focusAndSelect(tabs.length - 1);
        break;
      default:
        break;
    }
  };
  return <nav aria-label="Event type editor sections" className={className}>
      <div role="tablist" aria-orientation="vertical" aria-label="Event type editor tabs" className={navCss} data-testid="editor-tab-nav">
        {tabs.map((tab, index) => {
        const isActive = tab.key === activeTabKey;
        return <BareButton key={tab.key} ref={element => {
          tabRefs.current[index] = element;
        }} type="button" role="tab" id={tabId(tab.key)} aria-selected={isActive} aria-controls={tabPanelId(tab.key)} tabIndex={isActive ? 0 : -1} className={cx(tabItemCss, isActive && tabItemActiveCss)} data-testid={`editor-tab-${tab.key}`} onClick={() => onSelectTab(tab.key)} onKeyDown={event => handleKeyDown(event, index)}>
              <UiIcon icon={tab.icon} size="small" title="" />
              <span className={tabLabelCss}>{tab.label}</span>
              {invalidTabKeys.includes(tab.key) && !isActive && <UiIcon icon={IconAlertTriangleFilled} size="medium" color={colorTextWarning} title={I18n.t('publisher.event_type_editor_crud.tab_nav.has_error')} />}
            </BareButton>;
      })}
      </div>
    </nav>;
};

require("./tab_nav.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./tab_nav.js");